/**
 * @desc 导出退货单
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.AsMaterialRejectBillRequestParamsDto, options?: any) {
  return updateResponse(
    http(URL + `/asMaterialRejectBill/export`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
